import { MEDIA, STATS } from "@/data/content";
import { motion } from "framer-motion";

export default function About() {
  return (
    <section
      id="about"
      data-testid="about-section"
      className="relative bg-[#050505] py-24 md:py-32 px-6 md:px-12 lg:px-24 border-t border-white/10"
    >
      <div className="grid grid-cols-1 lg:grid-cols-12 gap-10 lg:gap-16 items-start">
        <motion.div
          initial={{ opacity: 0, y: 30 }}
          whileInView={{ opacity: 1, y: 0 }}
          viewport={{ once: true }}
          transition={{ duration: 0.8 }}
          className="lg:col-span-5 relative"
        >
          <div className="relative aspect-[4/5] overflow-hidden border border-white/10">
            <img
              src={MEDIA.portfolio2}
              alt="Director with camera on set"
              className="w-full h-full object-cover"
            />
            <div className="absolute inset-0 bg-gradient-to-t from-black/60 via-transparent to-transparent" />
            <div className="absolute bottom-5 left-5 font-mono text-[10px] uppercase tracking-[0.3em] text-white/80 bg-black/50 backdrop-blur px-2 py-1 border border-white/10">
              On Set — NYC
            </div>
          </div>

          <div className="hidden lg:block absolute -bottom-8 -right-8 bg-[#E50914] px-5 py-4">
            <div className="font-mono text-[10px] uppercase tracking-[0.3em] text-white/80">
              Founder
            </div>
            <div className="font-display uppercase text-white text-2xl leading-none mt-1">
              Mir
            </div>
          </div>
        </motion.div>

        <div className="lg:col-span-7">
          <p className="font-mono text-xs uppercase tracking-[0.3em] text-[#E50914] mb-6">
            // 03 — The Studio
          </p>
          <h2
            data-testid="about-title"
            className="font-display uppercase text-white text-5xl sm:text-6xl md:text-7xl leading-[0.9] mb-8"
          >
            Where vision <br />
            meets <span className="text-[#E50914]">execution.</span>
          </h2>
          <div className="space-y-5 text-zinc-300 text-base md:text-lg leading-relaxed max-w-2xl">
            <p>
              Millionare Mir Studio was built for artists who want more than
              content — they want impact. From high-energy music videos to raw,
              authentic photoshoots, we capture the essence of every artist and
              transform it into visuals that stand out.
            </p>
            <p>
              Every project is approached with a creative edge. Whether you're
              building your brand, dropping your next single, or launching a
              full visual rollout — we bring the tools, the direction, and the
              aesthetic to elevate your presence.
            </p>
            <p className="text-white font-medium">
              This isn't just production. It's a statement.
            </p>
          </div>

          <div className="mt-14 grid grid-cols-2 md:grid-cols-4 gap-px bg-white/10 border border-white/10">
            {STATS.map((s) => (
              <div
                key={s.label}
                data-testid={`stat-${s.label.toLowerCase().replace(/\s+/g, "-")}`}
                className="bg-[#0a0a0a] p-5 md:p-7"
              >
                <div className="font-display uppercase text-white text-4xl md:text-5xl leading-none">
                  {s.value}
                </div>
                <div className="mt-3 font-mono text-[10px] uppercase tracking-[0.25em] text-zinc-400">
                  {s.label}
                </div>
              </div>
            ))}
          </div>
        </div>
      </div>
    </section>
  );
}
